var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-category-small"},[_c('img',{attrs:{"width":"38","src":_vm.category.image}}),_c('span',[_vm._v(_vm._s(_vm.category.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }